const baseURL = 'https://eu-west-1.aws.data.mongodb-api.com/app/application-0-pcepj/endpoint/data/v1/shop/'

const ShopService = {
    getShop() {
        return fetch(baseURL)
            .then(res => res.json());
    },

    updateShop(shop) {
        return fetch(baseURL + shop._id, {
            method: 'PUT',
            body: JSON.stringify(shop),
            headers: {
                'Content-Type': 'application/json'
            }
        })
            .then(res => res.json());
    },

    addShop(shop) {
        return fetch(baseURL, {
          method: 'POST',
          body: JSON.stringify(shop),
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(res => res.json());
    },

    deleteShop(id) {
        return fetch(baseURL + id, {
          method: 'DELETE'
        });
    }
}

export default ShopService;